import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-profile-imp-notice',
  templateUrl: './profile-imp-notice.component.html',
  styleUrls: ['./profile-imp-notice.component.scss'],
  providers: [DatePipe],
})
export class ProfileImpNoticeComponent {
  @Input() theme = 'red';
  @Input() notificationMsg;
  @Output() closeIcon: EventEmitter<boolean> = new EventEmitter<boolean>();
  billedNoticeForUnenroll = false;
  impTextInNewLine: string;
  impTextIsScheduled: string;
  showTwoDaysOrLess: boolean;
  showMoreThanTwoDays: boolean;
  isAcmic: boolean;
  constructor(
    private acmicService: AcmicService
  ) {
    this.isAcmic = this.acmicService.isACMIC();
  }
  onClose() {
    this.closeIcon.emit(true)
  }
}
